// removed by extract-text-webpack-plugin
module.exports = {"errorBox":"Error__errorBox___2hG6j"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/error/Error.scss
// module id = 528
// module chunks = 0